import { Controller } from "@hotwired/stimulus";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock-upgrade";
import { Reviews } from "../components";

export default class extends Controller {
  static targets = ["wrapper", "content", "close", "backdrop", "reviews"];

  async openQuickshop(e) {
    this.wrapperTarget.classList.add("quickshop-wrap--active");
    this.contentTarget.classList.add("quickshop--loading");
    const { productHandle, productId, variant } = e.params;

    try {
      disableBodyScroll(document.querySelector(".quickshop"));

      const res = await fetch(
        `/products/${productHandle}?variant=${variant}&view=quickshop`
      );

      const html = await res.text();
      const wrapper = document.createElement("div");
      wrapper.innerHTML = html;

      this.contentTarget.innerHTML = wrapper.innerHTML;
      if (this.hasReviewsTarget) {
        const reviews = new Reviews();
        this.contentTarget.classList.remove("quickshop--loading");
        const reviewData = await reviews.fetchReviews({ productId });

        if (reviewData) {
          const { total_review: total, average_score: score } =
            reviewData.response.bottomline;

          if (total <= 0) return;

          const roundedScore = Math.floor(score);
          let scoreDifference = score;
          const generateStars = () => {
            let stars = "";
            while (scoreDifference > 0) {
              if (scoreDifference >= 1) {
                stars += `<span class="full-star"></span>`;
              } else if (scoreDifference >= 0.5) {
                stars += `<span class="half-star"></span>`;
              } else {
                stars += `<span class="empty-star"></span>`;
              }
              scoreDifference--;
            }

            return stars;
          };

          this.reviewsTarget.innerHTML = `<div class="reviews-badge reviews-badge--white" data-visible-stars="${roundedScore}">
          <div class="reviews-badge__stars">
            ${generateStars()}
          </div>
          <div class="reviews-badge__text">
            <span class="reviews-badge__text__count">${total}</span>
            <span class="reviews-badge__text__label">review${
              total > 1 ? "s" : ""
            }</span>
          </div>
        </div>`;
        }

        this.reviewsTarget.addEventListener("click", () => {
          window.location.href = `/products/${productHandle}?reviews-open=true`;
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.reviewsTarget.classList.remove("quickshop__reviews--loading");
    }
  }

  closeQuickshop() {
    this.wrapperTarget.classList.remove("quickshop-wrap--active");

    setTimeout(() => {
      this.contentTarget.innerHTML = "";
    }, 300);

    enableBodyScroll(document.querySelector(".quickshop"));
  }
}
